import { DailyTransactionTypeEnum } from "../../../../../models";
import { useSystemConfigurationsStore } from "../../stores/useSystemConfigurationsStore";
import {useCallback, useEffect} from "react";

interface UseSystemConfigurationProps {
    transactionType: DailyTransactionTypeEnum;
    formId: number;
}

export const useSystemConfigurationsContext = ({
                                           transactionType,
                                           formId,
                                       }: UseSystemConfigurationProps) => {
    //#region State & Store
    const store = useSystemConfigurationsStore();
    const {
        loadConfigurations,
        resetState,
        userSetting,
        companySetting,
        userTransactionSetting,
        userTransactionSettingList,
        systemModulesConfigurations,
        genericSystemConfigurations,
        isLoaded,
        loading,
    } = store;
    //#endregion
    //#region functions
    const initialize = useCallback(async () => {
        try {
            await loadConfigurations(transactionType, formId);
        } catch (err) {
            const errorMessage =
                err instanceof Error ? err.message : "Failed to load system configurations";
            console.error("System configuration initialization failed:", err);
        }
    }, [transactionType, formId]);
    const reset = useCallback(() => {
        resetState();
    }, []);
    //#endregion
    //#region Effects
    useEffect(() => {
        if (!isLoaded) {
            initialize().then(() => {});
        }
    }, [transactionType]);
    //#endregion
    //#region Return Values
    return {
        // Inputs
        transactionType,
        formId,
        userSetting,
        companySetting,
        userTransactionSetting,
        userTransactionSettingList,
        genericSystemConfigurations,
        systemModulesConfigurations,
        // State flags
        loading,
        isLoaded,
        // Actions
        initialize,
        reset,
    };
    //#endregion
};